import { render, staticRenderFns } from "./ResolutionUploaderComponent.vue?vue&type=template&id=5a2f4a76&"
import script from "./ResolutionUploaderComponent.vue?vue&type=script&lang=js&"
export * from "./ResolutionUploaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports